module.exports = __webpack_public_path__ + "img/img-chuanyuan-s2.71e5c52b.jpg";